import defaultLogger  from "./defaultLogger";

export default function loadAmazonConnect(logger) {
  logger = logger ?? defaultLogger;
  var scriptTag = document.createElement("script");
  scriptTag.type = "text/javascript";
  var jabraIntegrationDiv = document.createElement("div");
  jabraIntegrationDiv.id = "jabraIntegrationDiv";
  jabraIntegrationDiv.style = "width: 400px;height: 800px; display:none";
  document.body.appendChild(jabraIntegrationDiv);
  jabraIntegrationDiv.appendChild(scriptTag);

  var instanceURL = window.amazonConnectCcpUrl;
  logger.info("Loading Jabra amazon connect integration...");
  try {
    connect.core.initCCP(jabraIntegrationDiv, {
      ccpUrl: instanceURL,
      loginPopup: false,
      softphone: { allowFramedSoftphone: false },
    });
    logger.info("Jabra integration loaded with following ccp url: ", instanceURL);
  } catch (error) {
    logger.error("Following error on initCCP: ");
    logger.error(error);
  }
}
